// Data/Forms/Bookings/headers.js
const headers = {
    name: "Bookings",
    navigate: {
        path: [
            {
                name: "Bookings",
                path: "/app/sales/bookings",
            },
            {
                name: "Add",
                path: "",
            },
        ],
    },
};

export default headers;